import React from "react";

const UnderConstruction = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex flex-col items-center justify-center p-4 text-center">
      <div className="max-w-2xl w-full bg-white rounded-xl shadow-lg p-8 md:p-12 space-y-6">
        {/* Construction Icon */}
        <div className="flex justify-center">
          <div className="bg-yellow-400 p-4 rounded-full">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-16 w-16 text-yellow-800"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
              />
            </svg>
          </div>
        </div>

        {/* Heading */}
        <h1 className="text-3xl md:text-4xl font-bold text-gray-800">
          We're Under Construction
        </h1>

        {/* Description */}
        <p className="text-lg text-gray-600">
          Exciting things are coming soon! We're working hard to bring you an
          amazing experience.
        </p>

        {/* Countdown or Progress (optional) */}
        <div className="w-full bg-gray-200 rounded-full h-4">
          <div
            className="bg-blue-600 h-4 rounded-full animate-pulse"
            style={{ width: "65%" }}
          ></div>
        </div>
        <p className="text-sm text-gray-500">65% complete</p>

        {/* Contact/Social Links */}
        <div className="pt-4 flex justify-center space-x-4">
          <a
            href="mailto:info@techpression.com"
            className="text-blue-600 hover:text-blue-800"
          >
            Contact Us
          </a>
          <span className="text-gray-300">|</span>
          <a
            href="https://x.com/Techpressionews?t=nC2itf9nt1SzRcibFuL2lg&s=09"
            className="text-blue-600 hover:text-blue-800"
          >
            Twitter
          </a>
          <span className="text-gray-300">|</span>
          <a
            href="https://www.instagram.com/techpressionews?igsh=OXBhcXh2bTJtNms3"
            className="text-blue-600 hover:text-blue-800"
          >
            Instagram
          </a>
        </div>

        {/* Footer Note */}
        <p className="text-sm text-gray-400 mt-8">
          Thank you for your patience. We'll be back soon!
        </p>
      </div>
    </div>
  );
};

export default UnderConstruction;
